import { Directive, Input } from '@angular/core';
import { AbstractControl, NG_VALIDATORS } from '@angular/forms';

import { ComparisonDirective } from './comparison.directive';
export class LowerThanOrEqualDirective extends ComparisonDirective {
public ngLowerThanOrEqual: any;
constructor() {
    super('ngLowerThanOrEqual');
  }
/**
 * @param {?} control
 * @return {?}
 */
validateCore(control: AbstractControl): boolean {
    return control.value <= this.ngLowerThanOrEqual;
  }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: '[ngLowerThanOrEqual]',
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: LowerThanOrEqualDirective,
      multi: true
    }
  ]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'ngLowerThanOrEqual': [{ type: Input },],
};
}

function LowerThanOrEqualDirective_tsickle_Closure_declarations() {
/** @type {?} */
LowerThanOrEqualDirective.decorators;
/**
 * @nocollapse
 * @type {?}
 */
LowerThanOrEqualDirective.ctorParameters;
/** @type {?} */
LowerThanOrEqualDirective.propDecorators;
/** @type {?} */
LowerThanOrEqualDirective.prototype.ngLowerThanOrEqual;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
